"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TierConfig = exports.TierProcessingUnitsAllocation = exports.TierTimeAllocation = exports.OrganisationTier = exports.OrganisationStatus = void 0;
var OrganisationStatus;
(function (OrganisationStatus) {
    OrganisationStatus["ACTIVE"] = "active";
    OrganisationStatus["INACTIVE"] = "inactive";
})(OrganisationStatus = exports.OrganisationStatus || (exports.OrganisationStatus = {}));
var OrganisationTier;
(function (OrganisationTier) {
    OrganisationTier["FREE"] = "free";
    OrganisationTier["STARTER"] = "starter";
    OrganisationTier["BASIC"] = "basic";
    OrganisationTier["PRO"] = "pro";
    OrganisationTier["ENTERPRISE"] = "enterprise";
})(OrganisationTier = exports.OrganisationTier || (exports.OrganisationTier = {}));
/**
 * @deprecated Use TierConfig instead.
 */
var TierTimeAllocation;
(function (TierTimeAllocation) {
    TierTimeAllocation[TierTimeAllocation["FREE"] = Math.round(300 / 1.15)] = "FREE";
    TierTimeAllocation[TierTimeAllocation["STARTER"] = Math.round(8000 / 1.15)] = "STARTER";
    TierTimeAllocation[TierTimeAllocation["BASIC"] = Math.round(120000 / 1.15)] = "BASIC";
    TierTimeAllocation[TierTimeAllocation["PRO"] = Math.round(400000 / 1.15)] = "PRO";
    TierTimeAllocation[TierTimeAllocation["ENTERPRISE"] = -1] = "ENTERPRISE";
})(TierTimeAllocation = exports.TierTimeAllocation || (exports.TierTimeAllocation = {}));
/**
 * @deprecated Use TierConfig instead.
 */
var TierProcessingUnitsAllocation;
(function (TierProcessingUnitsAllocation) {
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["FREE"] = 300] = "FREE";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["STARTER"] = 8000] = "STARTER";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["BASIC"] = 120000] = "BASIC";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["PRO"] = 400000] = "PRO";
    TierProcessingUnitsAllocation[TierProcessingUnitsAllocation["ENTERPRISE"] = -1] = "ENTERPRISE";
})(TierProcessingUnitsAllocation = exports.TierProcessingUnitsAllocation || (exports.TierProcessingUnitsAllocation = {}));
exports.TierConfig = {
    free: {
        name: 'Free',
        timeAllocation: Math.round(300 / 1.15),
        unitAllocation: 300
    },
    starter: {
        name: 'Starter',
        timeAllocation: Math.round(8000 / 1.15),
        unitAllocation: 8000
    },
    basic: {
        name: 'Basic',
        timeAllocation: Math.round(120000 / 1.15),
        unitAllocation: 120000
    },
    pro: {
        name: 'Pro',
        timeAllocation: Math.round(400000 / 1.15),
        unitAllocation: 400000
    },
    enterprise: {
        name: 'Enterprise',
        timeAllocation: -1,
        unitAllocation: -1
    }
};
